import { useState, useEffect } from 'react'

interface Notification {
  name: string
  city: string
  product: string
}

const notifications: Notification[] = [
  {
    name: 'Carlos M.',
    city: 'Buenos Aires',
    product: 'COMBO INDUSTRIAL',
  },
  {
    name: 'Roberto S.',
    city: 'Córdoba',
    product: 'COMBO INDUSTRIAL',
  },
  { name: 'Miguel T.', city: 'Rosario', product: 'PLC MASTER' },
  {
    name: 'Juan P.',
    city: 'Mendoza',
    product: 'COMBO INDUSTRIAL',
  },
  {
    name: 'Fernando G.',
    city: 'La Plata',
    product: 'COMBO INDUSTRIAL',
  },
  {
    name: 'Jorge L.',
    city: 'Salta',
    product: 'COMBO INDUSTRIAL',
  },
  { name: 'Andrés B.', city: 'Neuquén', product: 'PLC MASTER' },
  {
    name: 'Ricardo D.',
    city: 'Tucumán',
    product: 'COMBO INDUSTRIAL',
  },
]

export function usePurchaseNotifications() {
  const [notification, setNotification] = useState<Notification | null>(null)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    let currentIndex = 0

    const showNotification = () => {
      setNotification(notifications[currentIndex])
      setIsVisible(true)

      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false)
      }, 4000)

      currentIndex = (currentIndex + 1) % notifications.length
    }

    // First notification after 5 seconds
    const firstTimeout = setTimeout(showNotification, 5000)

    // Subsequent notifications every 15 seconds
    const interval = setInterval(showNotification, 15000)

    return () => {
      clearTimeout(firstTimeout)
      clearInterval(interval)
    }
  }, [])

  return { notification, isVisible }
}
